module.exports = Object.freeze({
  API_ERROR: "Oops, something went wrong",
  SERVICE_UNAVAILABLE_ERROR:
    "Service currently unavailable, please try again later.",
});
